module.exports = __webpack_public_path__ + "fonts/no-price-alerts.svg";